<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    @close="_cancle"
    lock-scroll
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
  >
    <div v-loading="isLoading" class="content">
      <el-form
        ref="formRef"
        :rules="rules"
        label-position="top"
        :model="formData"
        class="platform-modify__form"
      >
        <el-form-item label="权限类型:" prop="permissionType">
          <el-radio-group
            v-model="formData.permissionType"
            :disabled="formType === 'edit'"
            @change="_changeType"
          >
            <el-radio :label="1">文件夹</el-radio>
            <el-radio :label="2">菜单</el-radio>
            <el-radio :label="3">按钮</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="权限名称:" prop="permissionName">
          <el-input
            v-model="formData.permissionName"
            placeholder="必填，32位字符长度"
            style="width: 440px"
          ></el-input>
        </el-form-item>
        <el-form-item label="父级:" prop="parentPermissionCode">
          <el-cascader
            v-model="formData.parentPermissionCode"
            :options="availableParents"
            :props="cascaderProps"
            :show-all-levels="false"
            :popper-append-to-body="false"
            placeholder="请选择"
            style="width: 440px"
            popper-class="cascader-poper"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="权限路径:" prop="url">
          <el-input
            v-model="formData.url"
            placeholder="必填，允许重复，格式不限"
            style="width: 440px"
          ></el-input>
        </el-form-item>
        <el-form-item label="权限编码:" prop="permissionCode">
          <el-input
            v-model="formData.permissionCode"
            :disabled="formType === 'edit'"
            placeholder="必填"
            style="width: 440px"
          ></el-input>
        </el-form-item>
        <el-form-item label="显示顺序:" prop="sort">
          <el-input
            v-model="formData.sort"
            placeholder="请输入"
            style="width: 440px"
          ></el-input>
          <span class="input-tips">选填，仅支持整数</span>
        </el-form-item>
        <el-form-item label="菜单图标样式:">
          <el-input
            v-model="formData.iconStr"
            placeholder="请输入"
            style="width: 440px"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <div class="dialog-footer">
        <div class="edit__btns">
          <el-button type="primary" class="save__btn" @click="_submit">
            保存
          </el-button>
          <el-button class="cancel__btn" @click="_cancle">取消</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: "permission-modify",
  props: {
    title: { default: "", type: String },
    formType: { type: String, default: "add" },
    appId: { type: String, default: "" },
    currPermission: { type: Object, default: () => {} },
    modalData: { type: Object, default: () => {} },
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      cascaderProps: {
        checkStrictly: true,
        value: "permissionCode",
        children: "childs",
        label: "permissionName",
      },
      parentsList: [],
      formData: {
        permissionName: "",
        permissionCode: "",
        parentPermissionCode: [],
        url: "",
        permissionType: 1,
        sort: null,
        iconStr: ''
      },
      rules: {
        permissionName: [
          { required: true, message: "请输入权限名称", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== "" && value.length > 32) {
                callback(new Error("最多32个字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        permissionType: [
          {
            required: true,
            type: "number",
            message: "请选择",
            trigger: "change",
          },
        ],
        permissionCode: [
          { required: true, message: "请输入权限编码", trigger: "blur" },
        ],
        parentPermissionCode: [
          {
            required: true,
            type: "string",
            message: "请选择",
            trigger: "change",
            transform(val) {
              let base;
              if (val && Array.isArray(val)) {
                base = val.toString();
              } else if (val) {
                base = "" + val;
              }
              return base;
            },
          },
        ],
        url: [{ required: true, message: "请输入权限路径", trigger: "blur" }],
        sort: [
          {
            validator: (rule, value, callback) => {
              const system = /^([1-9]\d{0,3}|1000)$/;
              if (value && !system.test(value)) {
                callback(new Error("只能输入1-1000之间的数字!"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    availableParents() {
      this.Recursive(this.parentsList);
      return this.parentsList;
    },
  },
  async mounted() {
    this.visible = true;
    this.isLoading = true;
    try {
      await this.$service
        .post("getPermsTree", {
          appId: this.appId,
        })
        .then((res) => {
          if (res.data) {
            this.parentsList = [res.data];
          }
        });
    } catch (err) {
      console.error(err);
    } finally {
      this.isLoading = false;
    }
    if (this.formType === "edit" && Object.keys(this.modalData).length > 0) {
      this.formData.permissionName = this.modalData.permissionName;
      this.formData.permissionCode = this.modalData.permissionCode;
      this.formData.parentPermissionCode = this.findParents(this.parentsList, this.modalData.parentPermissionCode);
      this.formData.url = this.modalData.url;
      this.formData.permissionType = this.modalData.permissionType;
      this.formData.sort = this.modalData.sort;
      this.formData.iconStr = this.modalData.iconStr;
    } else {
      // 权限类型，1、文件夹 2、菜单 3、按钮
      if (this.currPermission.permissionType !== 3) {
        this.formData.parentPermissionCode = this.findParents(this.parentsList, this.currPermission.permissionCode);
        this.formData.permissionType = this.currPermission.permissionType || 1;
      }
    }
  },
  methods: {
    // 通过子节点找所有父节点
    findParents(treeList, permissionCode) {
      var temp = [];
      var loop = function(arr, permissionCode) {
        for (var i = 0; i < arr.length; i++) {
          var item = arr[i];
          if (item.permissionCode === permissionCode) {
            temp.push(item.permissionCode);
            loop(treeList, item.parentPermissionCode);
            break;
          } else {
            if (item.childs) {
              loop(item.childs, permissionCode);
            }
          }
        }
      };
      loop(treeList, permissionCode);
      return temp.reverse();
    },
    Recursive(list) {
      list.map((item) => {
        // 只要节点权限小于权限类型就禁用，不可选。
        if(item.permissionType > this.formData.permissionType) {
          item.disabled = true
        }else {
          item.disabled = false
        }
        if (item.childs) {
          this.Recursive(item.childs);
        }
      });
    },
    _changeType() {
      this.formData.parentPermissionCode = [];
    },
    _cancle() {
      this.visible = false;
      this.$emit("close");
    },
    _submit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          this.isLoading = true;
          try {
            let postData = {
              ...this.formData,
              appId: this.appId,
            };
            if (Array.isArray(this.formData.parentPermissionCode)) {
              const [parentPermissionCode] = [
                ...this.formData.parentPermissionCode,
              ].reverse();
              Object.assign(postData, { parentPermissionCode });
            }

            if (this.formType === "edit") {
              Object.assign(postData, {
                permissionId: this.modalData.permissionId,
              });
            }
            const self = this;
            postData.sort = postData.sort ? postData.sort : null

            await this.$service.post("savePerms", postData).then((result) => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self.visible = false;
                    self.$emit("callback");
                  },
                });
              }
            });
          } catch (err) {
            console.error(err);
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px 30px;
  height: 100%;
  .input-tips {
    margin-left: 10px;
  }
}
</style>
